import React, { useEffect, useState } from "react";
import useProgressiveList from "../../../customHooks/useProgressiveList";
import {
  Box,
  Typography,
  Stack,
  Button,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { createStyledIndicatorButton } from "../../../common/StyledComponents/SideBarComponents";
import { useDispatch } from "react-redux";
import {
  AccountLevelArkchatPermission,
  InviteType,
  subscriptionPlanType,
} from "../../../utils/constant";
import {
  billingFormData,
  getAllSubscribedUsers,
  getBillingAddress,
  updateSubscription,
} from "../../../appStore/actions/Subscription/action";
import { groupExternalMember } from "../../../utils/externalMemberGroping";
import { useTranslation } from "react-i18next";
import no_member_icon from "../../../assets/images/chats/no_member_icon.svg";
import { showToastMsg } from "../../../appStore/actions/global/action";
import PersonIcon from "../../../assets/images/chats/person.svg";
import {
  checkAllSubscriptionCanceled,
  checkParticularSubscriptionCanceled,
  logWrapper,
} from "../../../utils/helper";
import useAppSelectors from "../../../customHooks/useAppSelectors";
import { requestGetGroupRecipient } from "../../../appStore/actions/ArkchatGroup/action";

import { crossIcon, crossIconDiv, personIconStyle } from "../../../assets/commonFunction";
const classes = {
  drawerBody: {
    minWidth: "31.25rem",
    maxWidth: "31.25rem",
    height: "100%",
    position: "relative",
  },
  header: {
    backgroundColor: "#F9F8F8",
    color: "#0000",
    padding: "7px 8px",
    mb: "1rem",
  },
  iconDiv: crossIconDiv,
  iconn: crossIcon,
  internalExternalButton: {
    background: "white",
    border: "1px solid #183243",
    color: "#183243",
    borderRadius: "2px",
    fontSize: "0.75rem",
    textTransform: "none",
    "&:hover": {
      background: "white",
    },
  },

  activeButton: {
    "&:hover": {
      background: "#183243",
    },
    background: "#183243",
    borderRadius: "2px",
    color: "white",
    fontSize: "0.75rem",
    textTransform: "none",
    border: "1px solid #183243",
  },
  activeToggelButton: {
    backgroundColor: "#183243",
    color: "#fff",
    padding: "2px",
    fontSize: "0.75rem",
    borderRadius: "3px",
    borderTopLeftRadius: "0px",
    borderBottomLeftRadius: "0px",
    textTransform: "none",
    borderColor: "#183243",
    ":hover": {
      backgroundColor: "#183243",
      color: "#fff",
      borderRadius: "3px",
      borderColor: "#183243",
    },
  },
  inactiveToggelButton: {
    backgroundColor: "#fff",
    color: "#183243",
    borderColor: "#183243",
    padding: "2px",
    fontSize: "0.75rem",
    borderRadius: "3px",
    borderTopLeftRadius: "0px",
    borderBottomLeftRadius: "0px",
    textTransform: "none",
    ":hover": {
      backgroundColor: "#fff",
      color: "#183243",
      borderRadius: "3px",
      borderColor: "#183243",
    },
  },
};

const ToggelManageMemberDrawer = ({
  setToggelManageMemberDrawerOpen,
  setBillingFormDrawerOpen,
  drawerType = "buy",
}) => {
  const NameBadge = createStyledIndicatorButton("#E3E1E1");
  const { t } = useTranslation();
  const appContent = t("AppContent", { returnObjects: true });
  const [activeButton, setActiveButton] = useState("internal");
  const [selectedInternalMemberData, setSelectedInternalMemberData] = useState([
    // { userId: string, planType: number }
  ]);
  const [selectedExternalMemberData, setSelectedExternalMemberData] = useState({
    // { companyName: [{ userId: string, planType: number }] }
  });
  const [externalMemberData, setExternalMemberData] = useState([]);
  const {
    currentUserData,
    accountLevelPeople,
    selectedPlanData,
    billingData,
    selectedManageSubscriptionData,
    allSubscribedUsers,
    selectedGroup,
    subscriptionDetails,
  } = useAppSelectors();
  const [availableYearlyLicenses, setAvailableYearlyLicenses] = useState(
    allSubscribedUsers?.tally?.balance || 0
  );

  const dispatch = useDispatch();

  const handleClickMemberTypeSwitch = (type) => {
    setActiveButton(type);
  };

  // Determine default plan type
  const getDefaultPlanType = (selectedPlanData) => {
    // return selectedPlanData?.planType
    // ? selectedPlanData?.planType
    // : selectedPlanData?.interval === "month"
    // ? 1
    // : selectedPlanData?.interval === "day"
    // ? 3
    // : selectedPlanData?.interval === "week"
    // ? 4
    // : 2
    return selectedPlanData?.planType
      ? selectedPlanData?.planType
      : selectedPlanData?.interval === "yearly"
      ? subscriptionPlanType?.Yearly 
      : subscriptionPlanType?.Monthly; 
  };
  const handleSelectInternalMember = (
    event,
    internalUserData,
    planType = null
  ) => {
    if (event.target.checked || event.target.innerText === appContent?.KEY217) {
      const defaultPlanType = getDefaultPlanType(
        selectedManageSubscriptionData
      );

      // Determine the plan type
      const finalPlanType = planType ? planType : defaultPlanType;

      // Check if trying to add a yearly license
      if (
        finalPlanType === 2 &&
        allSubscribedUsers?.tally?.total > 0 &&
        availableYearlyLicenses <= 0
      ) {
        dispatch(showToastMsg("No more yearly licenses available"));
        return;
      }

      const newMemberData = {
        user_id: internalUserData?.userId,
        plan_type: finalPlanType,
      };

      // Update available yearly licenses if adding a yearly license
      const updatedAvailableLicenses =
        finalPlanType === 2
          ? availableYearlyLicenses - 1
          : availableYearlyLicenses;

      setAvailableYearlyLicenses(updatedAvailableLicenses);

      setSelectedInternalMemberData([
        ...selectedInternalMemberData,
        newMemberData,
      ]);
    } else {
      // When removing a member, check if it was a yearly license and adjust available licenses
      const removedMember = selectedInternalMemberData.find(
        (member) => member.user_id === internalUserData?.userId
      );

      const updateInternUserData = selectedInternalMemberData?.filter(
        (member) => member.user_id !== internalUserData?.userId
      );

      // Restore yearly license if the removed member was on a yearly plan
      const updatedAvailableLicenses =
        removedMember?.plan_type === 2
          ? availableYearlyLicenses + 1
          : availableYearlyLicenses;

      setAvailableYearlyLicenses(updatedAvailableLicenses);
      setSelectedInternalMemberData(updateInternUserData);
    }
  };

  const handleSelectExternalPerson = (
    event,
    selectedPerson,
    companyName,
    planType = null
  ) => {
    if (event.target.checked) {
      // Default plan type when selecting
      const defaultPlanType = getDefaultPlanType(
        selectedManageSubscriptionData
      );
      // Determine the plan type
      const finalPlanType = planType ? planType : defaultPlanType;

      // Check if trying to add a yearly license
      if (
        finalPlanType === 2 &&
        allSubscribedUsers?.tally?.total > 0 &&
        availableYearlyLicenses <= 0
      ) {
        dispatch(showToastMsg("No more yearly licenses available"));
        return;
      }

      const newMemberData = {
        user_id: selectedPerson?.userId,
        plan_type: finalPlanType,
      };

      if (selectedExternalMemberData[companyName]?.length > 0) {
        const updatedCompanyMembers = [
          ...selectedExternalMemberData[companyName],
          newMemberData,
        ];
        setSelectedExternalMemberData({
          ...selectedExternalMemberData,
          [companyName]: updatedCompanyMembers,
        });
      } else {
        setSelectedExternalMemberData({
          ...selectedExternalMemberData,
          [companyName]: [newMemberData],
        });
      }
      const updatedAvailableLicenses =
        finalPlanType === 2
          ? availableYearlyLicenses - 1
          : availableYearlyLicenses;

      setAvailableYearlyLicenses(updatedAvailableLicenses);
    } else {
      // Remove the user when unchecked
      const removedMember = selectedExternalMemberData[companyName]?.find(
        (member) => member.user_id === selectedPerson?.userId
      );
      const updatedCompanyMembers = selectedExternalMemberData[
        companyName
      ]?.filter((member) => member.user_id !== selectedPerson?.userId);
      const updatedAvailableLicenses =
        removedMember?.plan_type === 2
          ? availableYearlyLicenses + 1
          : availableYearlyLicenses;

      setAvailableYearlyLicenses(updatedAvailableLicenses);
      setSelectedExternalMemberData({
        ...selectedExternalMemberData,
        [companyName]: updatedCompanyMembers || [],
      });
    }
  };
  
  const toggleInternalMemberPlanType = (user_id, plan_type) => {
    const currentMember = selectedInternalMemberData.find(
      (member) => member.user_id === user_id
    );

    // Check if switching to yearly and no licenses available
    if (
      currentMember.plan_type === 1 &&
      allSubscribedUsers?.tally?.total &&
      availableYearlyLicenses <= 0
    ) {
      dispatch(showToastMsg("No more yearly licenses available"));
      return;
    }

    const updatedInternalMemberData = selectedInternalMemberData.map((member) =>
      member.user_id === user_id
        ? {
            ...member,
            plan_type: plan_type,
            // plan_type: member.plan_type === 1 ? 2 : 1,
          }
        : member
    );

    // Update available yearly licenses
    const updatedAvailableLicenses =
      currentMember.plan_type === 1
        ? availableYearlyLicenses - 1
        : availableYearlyLicenses + 1;

    setAvailableYearlyLicenses(updatedAvailableLicenses);
    setSelectedInternalMemberData(updatedInternalMemberData);
  };

  const toggleExternalMemberPlanType = (companyName, user_id, plan_type) => {
    const updatedExternalMemberData = { ...selectedExternalMemberData };

    const currentMember = updatedExternalMemberData[companyName].find(
      (member) => member.user_id === user_id
    );

    if (
      currentMember.plan_type === 1 &&
      allSubscribedUsers?.tally?.total &&
      availableYearlyLicenses <= 0
    ) {
      dispatch(showToastMsg("No more yearly licenses available"));
      return;
    }

    // Check if switching to yearly and no licenses available
    if (
      currentMember.plan_type === 1 &&
      allSubscribedUsers?.tally?.total &&
      availableYearlyLicenses <= 0
    ) {
      dispatch(showToastMsg("No more yearly licenses available"));
      return;
    }

    const companyMembers = updatedExternalMemberData[companyName].map(
      (member) =>
        member.user_id === user_id
          ? {
              ...member,
              // plan_type: member.plan_type === 1 ? 2 : 1,
              plan_type: plan_type,
            }
          : member
    );

    // Update available yearly licenses
    const updatedAvailableLicenses =
      currentMember.plan_type === 1
        ? availableYearlyLicenses - 1
        : availableYearlyLicenses + 1;

    setAvailableYearlyLicenses(updatedAvailableLicenses);

    updatedExternalMemberData[companyName] = companyMembers;
    setSelectedExternalMemberData(updatedExternalMemberData);
  };

  useEffect(() => {
    if (accountLevelPeople && allSubscribedUsers?.members) {
      // Modify internal user selection
      // const selectedInternalUser = accountLevelPeople?.internalMember
      //   ?.filter((item) =>
      //     allSubscribedUsers.members.some(
      //       (member) => member.userId === item?.userId
      //     )
      //   )
      //   ?.map((item) => {
      //     const memberData = allSubscribedUsers.members.find(
      //       (member) => member.userId === item?.userId
      //     );
      //     return {
      //       user_id: item?.userId,
      //       plan_type: memberData.planType,
      //     };
      //   });
      const selectedInternalUser = accountLevelPeople?.internalMember
      ?.filter((item) =>
        allSubscribedUsers.members.some(
          (member) => member.userId === item?.userId
        )
      )
      ?.map((item) => {
        // Find the first plan type 1 for the user
        const memberData = allSubscribedUsers.members.find(
          (member) => member.userId === item?.userId && member.planType === subscriptionPlanType?.Yearly
        );
    
        // If no plan type 1 is found, fall back to the first plan (if needed)
        const fallbackMemberData = allSubscribedUsers.members.find(
          (member) => member.userId === item?.userId
        );
    
        return {
          user_id: item?.userId,
          plan_type: memberData ? memberData.planType : fallbackMemberData?.planType,
        };
      });

      setSelectedInternalMemberData([
        ...selectedInternalMemberData,
        ...selectedInternalUser,
      ]);

      // Modify external user selection
      if (accountLevelPeople?.externalMember?.length > 0) {
        const groupedExternalData = groupExternalMember(
          accountLevelPeople?.externalMember,
          false,
          appContent?.KEY34
        );

        const selectedExternalUser = accountLevelPeople?.externalMember?.filter(
          (item) =>
            allSubscribedUsers.members.some(
              (member) => member.userId === item?.userId
            )
        );

        if (selectedExternalUser?.length > 0) {
          const preSelectedExternalMember = groupExternalMember(
            selectedExternalUser,
            false,
            appContent?.KEY34
          );

          let externalMember = {};
          preSelectedExternalMember?.forEach((company) => {
            let userIds = Object.values(company)[0]?.map((item) => {
              const memberData = allSubscribedUsers.members.find(
                (member) => member.userId === item?.userId
              );
              return {
                user_id: item?.userId,
                plan_type: memberData.planType,
              };
            });
            externalMember = {
              ...externalMember,
              [Object.keys(company)[0]]: userIds,
            };
          });

          setSelectedExternalMemberData(externalMember);
        }
        setExternalMemberData(groupedExternalData);
      }
    }
    setAvailableYearlyLicenses(allSubscribedUsers?.tally?.balance || 0);
    dispatch(getBillingAddress());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accountLevelPeople, allSubscribedUsers]);

  // Handle save/next
  const handleClickNext = () => {
    let usersArr = [];

    // Collect internal members
    usersArr = selectedInternalMemberData.map((member) => ({
      user_id: member.user_id,
      plan_type: member.plan_type,
    }));

    // Collect external members
    for (let key in selectedExternalMemberData) {
      usersArr = [
        ...usersArr,
        ...selectedExternalMemberData[key].map((member) => ({
          user_id: member.user_id,
          plan_type: member.plan_type,
        })),
      ];
    }
    if (drawerType === "buy") {
      const reqBody = {
        ...billingData,
        users: usersArr,
        price: selectedPlanData?.price,
        plan_id: selectedPlanData?.prodId,
        currency: selectedPlanData?.currency,
        gateway: selectedPlanData?.gateway,
      };

      dispatch(billingFormData(reqBody));

      setBillingFormDrawerOpen(true);
    } else {
      const reqBody = {
        users: usersArr,
      };

      dispatch(updateSubscription(reqBody)).then((res) => {
        dispatch(showToastMsg(res?.message || "Something went wrong !"));
        dispatch(getAllSubscribedUsers());
        if (selectedGroup?.isGroup) {
          dispatch(requestGetGroupRecipient(selectedGroup?.id));
        }
        setToggelManageMemberDrawerOpen(false);
      });
    }
  };
  // A big account's people are built a part at a time as the list scrolls
  // (the tab shown: internal people, or external ones by company): building
  // every row at once took most of a second.
  const externalRowCount = externalMemberData.reduce((n, company) => n + (Object.values(company)[0]?.length || 0), 0);
  const tabRows = activeButton === "internal" ? accountLevelPeople?.internalMember?.length || 0 : externalRowCount;
  const [shownRows, listRef, moreRef] = useProgressiveList(tabRows);
  const visibleExternal = [];
  let externalBudget = shownRows;
  for (const company of externalMemberData) {
    if (externalBudget <= 0) break;
    const rows = (Object.values(company)[0] || []).slice(0, externalBudget);
    externalBudget -= rows.length;
    visibleExternal.push({ company, rows });
  }

  return (
    <Box sx={classes.drawerBody} overflow="hidden">
      <Stack
        direction="row"
        alignItems="center"
        spacing={2}
        sx={classes.header}
      >
        <Typography sx={classes.iconDiv}>
          <CloseIcon
            sx={classes.iconn}
            onClick={() => setToggelManageMemberDrawerOpen(false)}
          />
        </Typography>
        <Typography color={"black"}>{appContent?.KEY222}</Typography>
      </Stack>

      <Box width={"95%"} ml={"auto"}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          spacing={1}
          mt={"0.4rem"}
          mb={"0.4rem"}
          // border={"1px solid"}
        >
          <Stack
            direction="row"
            justifyContent="left"
            alignItems="center"
            spacing={1}
          >
            <Button
              sx={
                activeButton === "internal"
                  ? classes.activeButton
                  : classes.internalExternalButton
              }
              variant="contained"
              onClick={() => handleClickMemberTypeSwitch("internal")}
            >
              {appContent?.KEY171}
            </Button>
            <Button
              sx={
                activeButton === "external"
                  ? classes.activeButton
                  : classes.internalExternalButton
              }
              variant="contained"
              onClick={() => handleClickMemberTypeSwitch("external")}
            >
              {appContent?.KEY172}
            </Button>
          </Stack>
        </Stack>
        {allSubscribedUsers?.tally?.total > 0 && (
          <Box width={"80%"} mt={"0.8rem"}>
            <Box display={"flex"} justifyContent={"space-between"}>
              <Typography variant="caption">
                {appContent?.KEY225} :
              </Typography>
              <Typography>{allSubscribedUsers?.tally?.total}</Typography>
            </Box>
            <Box display={"flex"} justifyContent={"space-between"}>
              <Typography variant="caption">{appContent?.KEY227}:</Typography>
              <Typography>
                {allSubscribedUsers?.tally?.total - availableYearlyLicenses}
              </Typography>
            </Box>
            <Box display={"flex"} justifyContent={"space-between"}>
              <Typography variant="caption">{appContent?.KEY228}:</Typography>
              <Typography>{availableYearlyLicenses}</Typography>
            </Box>
          </Box>
        )}

        <Box
          ref={listRef}
          width={"90%"}
          overflow={"scroll"}
          height={"calc(100vh - 16rem)"}
          sx={{
            "&::-webkit-scrollbar": {
              width: "1px",
            },
            "&::-webkit-scrollbar-track": {
              background: "#F9F8F8",
            },
            "&::-webkit-scrollbar-thumb": {
              background: "grey",
            },
          }}
        >
          {activeButton === "internal" && (
            <Box>
              {accountLevelPeople?.internalMember?.slice(0, shownRows).map((item) => (
                <Stack
                  width={"100%"}
                  mb={"0.87rem"}
                  padding={"0px 4px 0px 2px"}
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  key={item?.userId + "internalInvitegrpmember"}
                >
                  <Box width={"62%"}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          sx={{
                            "& .MuiSvgIcon-root": {
                              fontSize: 30,
                              color: "#183243",
                            },
                          }}
                          checked={selectedInternalMemberData.some(
                            (member) => member.user_id === item?.userId
                          )}
                          onChange={(event) =>
                            handleSelectInternalMember(event, item)
                          }
                          disabled={
                            (item?.inviteType === InviteType?.ownerInviteType &&
                              (item?.permission ===
                                AccountLevelArkchatPermission?.ADMIN ||
                                currentUserData?.accountOwner)) ||
                            (item?.inviteType === InviteType?.internal &&
                              item?.permission ===
                                AccountLevelArkchatPermission?.ADMIN)
                          }
                          icon={
                            <NameBadge
                              sx={{ color: "#183243" }}
                              size="small"
                              variant="contained"
                            >
                              {/* <Typography
                                color={"#183243"}
                                fontSize={"0.75rem"}
                              >
                                {item?.userInfo?.firstName &&
                                  item?.userInfo?.firstName[0]}
                              </Typography> */}
                                <img
                            style={personIconStyle}
                            src={
                              PersonIcon
                            }
                            alt="individual"
                          />
                            </NameBadge>
                          }
                        />
                      }
                      label={
                        <Box>
                          <Typography
                            title={`${item?.userInfo?.firstName} ${item?.userInfo?.lastName}`}
                          >
                            {`${item?.userInfo?.firstName} ${item?.userInfo?.lastName}`
                              .length > 18
                              ? `${`${item?.userInfo?.firstName} ${item?.userInfo?.lastName}`.slice(
                                  0,
                                  18
                                )}...`
                              : `${item?.userInfo?.firstName} ${item?.userInfo?.lastName}`}
                            <>
                              {item?.inviteType ===
                                InviteType?.ownerInviteType &&
                                (item?.permission ===
                                  AccountLevelArkchatPermission?.ADMIN ||
                                  currentUserData?.accountOwner) &&
                                ", Owner"}
                              {item?.inviteType === InviteType?.internal &&
                                item?.permission ===
                                  AccountLevelArkchatPermission?.ADMIN &&
                                ", Admin"}
                            </>
                          </Typography>
                          {/* <Typography variant="caption">Admin</Typography> */}
                        </Box>
                      }
                    />
                  </Box>
                  <Box
                    width={"35%"}
                    display={"flex"}
                    alignItems={"center"}
                    gap={"0.5rem"}
                  >
                    {/*cross*/}
                    <Box display={"flex"}>
                      <Button
                        disabled={checkParticularSubscriptionCanceled(
                          subscriptionDetails,
                          2
                        )}
                        variant="outlined"
                        sx={{
                          ...(selectedInternalMemberData.some(
                            (m) => m.user_id === item?.userId && m.plan_type === subscriptionPlanType?.Yearly)
                            ? classes.activeToggelButton
                            : classes.inactiveToggelButton),
                        }}
                        onClick={() =>
                          selectedInternalMemberData.some(
                            (m) => m.user_id === item?.userId
                          )
                            ? toggleInternalMemberPlanType(item?.userId, 2)
                            : handleSelectInternalMember(
                                { target: { checked: true } },
                                item,
                                2
                              )
                        }
                      >
                        Yearly
                      </Button>
                      {/* <Button
                        variant="outlined"
                        sx={{
                          ...(selectedInternalMemberData.some(
                            (m) => m.user_id === item?.userId && m.plan_type === 4)
                            ? classes.activeToggelButton
                            : classes.inactiveToggelButton),
                        }}
                        onClick={() =>
                          selectedInternalMemberData.some(
                            (m) => m.user_id === item?.userId
                          )
                            ? toggleInternalMemberPlanType(item?.userId, 4)
                            : handleSelectInternalMember(
                                { target: { checked: true } },
                                item,
                                4
                              )
                        }
                      >
                        Weekly
                      </Button> */}
                      <Button
                        disabled={checkParticularSubscriptionCanceled(
                          subscriptionDetails,
                          1
                        )}
                        variant="outlined"
                        sx={{
                          ...(selectedInternalMemberData.some(
                            (m) => m.user_id === item?.userId && m.plan_type === subscriptionPlanType?.Monthly)
                            ? classes.activeToggelButton
                            : classes.inactiveToggelButton),
                        }}
                        onClick={() =>
                          selectedInternalMemberData.some(
                            (m) => m.user_id === item?.userId
                          )
                            ? toggleInternalMemberPlanType(item?.userId, 1)
                            : handleSelectInternalMember(
                                { target: { checked: true } },
                                item,
                                1
                              )
                        }
                      >
                        Monthly
                      </Button>
                    </Box>
                  </Box>
                </Stack>
              ))}
            </Box>
          )}

          {activeButton === "external" && (
            <Box>
              {visibleExternal.map(({ company, rows }, index) => (
                <Box mb={"0.87rem"} padding={"0px 4px 0px 2px"}>
                  <FormControlLabel
                    sx={{
                      cursor: "default",
                      ".MuiFormControlLabel-label": {
                        fontWeight: 500,
                        color: "#000000",
                      },
                    }}
                    control={
                      <Checkbox
                        sx={{
                          cursor: "default",
                          "& .MuiSvgIcon-root": {
                            fontSize: 30,
                            color: "#183243",
                          },
                        }}
                        checked={
                          Object.values(company)[0]?.length ===
                          selectedExternalMemberData[Object.keys(company)[0]]
                            ?.length
                        }
                        onChange={(event) => event.preventDefault}
                        icon={
                          <NameBadge
                            sx={{ color: "#183243" }}
                            size="small"
                            variant="contained"
                          >
                            <Typography
                              color={"#183243"}
                              fontSize={"0.75rem"}
                              fontWeight={600}
                            >
                              {Object.keys(company)[0] &&
                                Object.keys(company)[0][0]}
                            </Typography>
                          </NameBadge>
                        }
                      />
                    }
                    label={
                      <Typography
                        variant="h6"
                        fontSize={"1rem"}
                        fontWeight={600}
                      >
                        {Object.keys(company)[0]}
                      </Typography>
                    }
                  />
                  {rows.map((item, i) => (
                    <Stack
                      mb={"0.4rem"}
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                      spacing={1}
                      key={item?.userId + "externalInvitegrpmember"}
                    >
                      <Box width={"62%"} padding={"0rem 0rem 0rem 1.2rem"}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              disabled={item.membership}
                              sx={{
                                "& .MuiSvgIcon-root": {
                                  fontSize: 25,
                                  color: "#183243",
                                },
                              }}
                              checked={
                                selectedExternalMemberData[
                                  Object.keys(company)[0]
                                ]?.length > 0 &&
                                selectedExternalMemberData[
                                  Object.keys(company)[0]
                                ]?.some(
                                  (member) => member.user_id === item?.userId
                                )
                              }
                              onChange={(event) =>
                                handleSelectExternalPerson(
                                  event,
                                  item,
                                  Object.keys(company)[0]
                                )
                              }
                              icon={
                                <NameBadge
                                  sx={{
                                    color: "#183243",
                                    width: "1.55rem",
                                    height: "1.55rem",
                                  }}
                                  size="small"
                                  variant="contained"
                                >
                                  <Typography
                                    color={"#183243"}
                                    fontSize={"0.75rem"}
                                  >
                                    {item?.userInfo?.firstName &&
                                      item?.userInfo?.firstName[0]}
                                  </Typography>
                                </NameBadge>
                              }
                            />
                          }
                          label={
                            <Box
                              display={"flex"}
                              alignItems={"center"}
                              gap={"0.15rem"}
                            >
                              <Typography
                                title={`${item?.userInfo?.firstName} ${item?.userInfo?.lastName}`}
                              >
                                {`${item?.userInfo?.firstName} ${item?.userInfo?.lastName}`
                                  .length > 18
                                  ? `${`${item?.userInfo?.firstName} ${item?.userInfo?.lastName}`.slice(
                                      0,
                                      18
                                    )}...`
                                  : `${item?.userInfo?.firstName} ${item?.userInfo?.lastName}`}
                              </Typography>
                              {/* <Typography variant="caption">Admin</Typography> */}
                              {item.membership && (
                                <Box
                                  ml="0.4rem"
                                  sx={{
                                    height: "0.5rem",
                                    width: "0.5rem",
                                    borderRadius: "50%",
                                    bgcolor: "green",
                                  }}
                                ></Box>
                              )}
                            </Box>
                          }
                        />
                      </Box>

                      <Box
                        width={"35%"}
                        display={"flex"}
                        alignItems={"center"}
                        gap={"0.5rem"}
                      >
                        {/* <Box
                          display={"flex"}
                          alignItems={"center"}
                          border={"1px solid none"}
                          bgcolor={item?.membershipType ? "#E1E1E1" : "#fff"}
                          color={"#183243"}
                          borderRadius={"1rem"}
                          padding={"2px 6px"}
                          maxWidth={"4rem"}
                          height={"1.4rem"}
                          overflow={"hidden"}
                          textOverflow={"ellipsis"}
                          whiteSpace={"nowrap"}
                        >
                          <Typography
                            width={"4rem"}
                            fontSize={"0.7rem"}
                            title={item?.membershipType}
                            variant="caption"
                            sx={{
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {item?.membershipType}
                          </Typography>
                        </Box> */}
                        <Box display={"flex"}>
                          <Button
                            disabled={
                              checkParticularSubscriptionCanceled(
                                subscriptionDetails,
                                2
                              ) || item.membership
                            }
                            variant="outlined"
                            sx={{
                              ...(selectedExternalMemberData[
                                Object.keys(company)[0]
                              ]?.some((m) => m.user_id === item?.userId && m.plan_type === subscriptionPlanType?.Yearly)
                                ? classes.activeToggelButton
                                : classes.inactiveToggelButton),
                            }}
                            onClick={() =>
                              selectedExternalMemberData[
                                Object.keys(company)[0]
                              ]?.some((m) => m.user_id === item?.userId)
                                ? toggleExternalMemberPlanType(
                                    Object.keys(company)[0],
                                    item?.userId,
                                    2
                                  )
                                : handleSelectExternalPerson(
                                    { target: { checked: true } },
                                    item,
                                    Object.keys(company)[0],
                                    2
                                  )
                            }
                          >
                            Yearly
                          </Button>
                          {/* <Button
                            disabled={item.membership}
                            variant="outlined"
                            sx={{
                              ...(selectedExternalMemberData[
                                Object.keys(company)[0]
                              ]?.some((m) =>m.user_id === item?.userId && m.plan_type === 4)
                                ? classes.activeToggelButton
                                : classes.inactiveToggelButton),
                            }}
                            onClick={() =>
                              selectedExternalMemberData[
                                Object.keys(company)[0]
                              ]?.some((m) => m.user_id === item?.userId)
                                ? toggleExternalMemberPlanType(
                                    Object.keys(company)[0],
                                    item?.userId,
                                    4
                                  )
                                : handleSelectExternalPerson(
                                    { target: { checked: true } },
                                    item,
                                    Object.keys(company)[0],
                                    4
                                  )
                            }
                          >
                            Weekly
                          </Button> */}
                          <Button
                            disabled={
                              checkParticularSubscriptionCanceled(
                                subscriptionDetails,
                                1
                              ) || item.membership
                            }
                            variant="outlined"
                            sx={{
                              ...(selectedExternalMemberData[
                                Object.keys(company)[0]
                              ]?.some((m) => m.user_id === item?.userId && m.plan_type === subscriptionPlanType?.Monthly)
                                ? classes.activeToggelButton
                                : classes.inactiveToggelButton),
                            }}
                            onClick={() =>
                              selectedExternalMemberData[
                                Object.keys(company)[0]
                              ]?.some((m) => m.user_id === item?.userId)
                                ? toggleExternalMemberPlanType(
                                    Object.keys(company)[0],
                                    item?.userId,
                                    2
                                  )
                                : handleSelectExternalPerson(
                                    { target: { checked: true } },
                                    item,
                                    Object.keys(company)[0],
                                    1
                                  )
                            }
                          >
                            Monthly
                          </Button>
                        </Box>
                      </Box>
                    </Stack>
                  ))}
                </Box>
              ))}

              {accountLevelPeople?.externalMember?.length === 0 &&
                activeButton == "external" && (
                  <Stack mt={"4rem"} alignItems="center">
                    <img src={no_member_icon} alt="no_member" />
                    <Typography
                      fontSize={14}
                      width={"20rem"}
                      marginTop={"0.93rem"}
                    >
                      {appContent?.KEY271}
                    </Typography>
                  </Stack>
                )}
            </Box>
          )}
          {shownRows < tabRows && <Box ref={moreRef} height="1px" />}
        </Box>

        <Box
          position={"absolute"}
          bottom={"1rem"}
          width={"100%"}
          margin={"auto"}
          textAlign={"center"}
          mt={"2rem"}
        >
          <Button
            onClick={handleClickNext}
            disabled={
              drawerType !== "buy" &&
              checkAllSubscriptionCanceled(subscriptionDetails)
            }
            sx={{
              backgroundColor: "#DB0011",
              color: "#fff",
              padding: "0.4rem 2.4rem",
              textTransform: "none",
              borderRadius: "0.15rem",
              ":hover": {
                backgroundColor: "#DB0011",
                color: "#fff",
              },
            }}
            variant="contained"
          >
            {appContent?.KEY100}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default ToggelManageMemberDrawer;
